// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Open+Sans:wght@300;400;600;700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Open+Sans:wght@300;400;600;700&display=swap);"]);
// Module
exports.push([module.id, "._2RwAidpK2Ry_H69BV59DOa{text-align:center}._3lQApO6jzVzjEN2sKbWyUJ{cursor:pointer;text-decoration:underline}._3lQApO6jzVzjEN2sKbWyUJ:hover{opacity:.7}", ""]);
// Exports
exports.locals = {
	"passwordReset": "_2RwAidpK2Ry_H69BV59DOa",
	"text": "_3lQApO6jzVzjEN2sKbWyUJ"
};
module.exports = exports;
